import { getStateFromZipcode } from '../utils/zipcode-utils';

const validatePage = () => {
  if (
    window.digitalData.page
    && window.digitalData.page.pageInfo
    && window.digitalData.page.pageInfo.pageName
    && window.digitalData.page.pageInfo.pageType
  ) {
    return true;
  }
  return false;
};

const validateUser = () => {
  if (
    window.digitalData.user
    && window.digitalData.user.profile
    && window.digitalData.user.profile.authenticationStatus
  ) {
    return true;
  }
  return false;
};

const tryInitialize = () => {
  if (validatePage() && validateUser() && window?.ddoInit) {

    const pageInfo = window.digitalData?.page?.pageInfo || {};
    const key = `${pageInfo.pageName}|${pageInfo.pageType}`;

    // If this key already initialized, suppress duplicate
    if (window._analyticsPageInitKey === key) {
      return;
    }

    window._analyticsPageInitKey = key;
    window.ddoInit(window.digitalData);
  }
};

export const setPage = (page) => {
  window.digitalData.page = page;
  tryInitialize();
};

export const setPageInfo = (pageLoadEvent, pageName, pageType) => {
  const pageInfo = { pageLoadEvent, pageName, pageType };

  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  window.digitalData.page.pageInfo = pageInfo;
  tryInitialize();
};

export const setAdditionalPageInfo = (propertyName, additionalData) => {
  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  switch (propertyName) {
  case 'category':
    window.digitalData.page.category = { ...additionalData };
    break;
  case 'eventInfo':
    window.digitalData.page.inventInfo = { ...additionalData };
    break;
  case 'pageInfo':
    window.digitalData.page.pageInfo = { ...additionalData };
    break;
  case 'item':
    if (!window.digitalData.product) {
      window.digitalData.product = [];
    }
    window.digitalData.product.push(additionalData);
    break;
  case 'content':
    if (!window.digitalData.content) {
      window.digitalData.content = {};
    }
    if (!window.digitalData.content.module) {
      window.digitalData.content.module = [];
    }
    window.digitalData.content.module.push(additionalData);
    break;
  case 'displayAttributes':
    if (!window.digitalData.page.displayAttributes) {
      window.digitalData.page.displayAttributes = {};
    }
    window.digitalData.page.displayAttributes = { ...additionalData };
    break;
  case 'filter':
    if (!window.digitalData.page.filter) {
      window.digitalData.page.filter = [];
    }
    window.digitalData.page.filter.push(additionalData);
    break;
  default:
  }
};

export const setAuthenticationStatus = (authenticationStatus) => {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};

  window.digitalData.user.profile.authenticationStatus = authenticationStatus;
  tryInitialize();
};

export const setProfileInfo = (profileId) => {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};
  window.digitalData.user.profile.profileInfo = window.digitalData.user.profile.profileInfo || {};
  window.digitalData.user.profile.profileInfo.profileID = profileId;
};

export const setb2bProfile = ({
  userType, userId, accountId, shipToId, userTradeType
}) => {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.b2bProfile = window.digitalData.user.b2bProfile || {};
  window.digitalData.user.b2bProfile.userType = window.digitalData.user.b2bProfile.userType || {};
  window.digitalData.user.b2bProfile.userType = userType;
  window.digitalData.user.b2bProfile.userID = window.digitalData.user.b2bProfile.userID || {};
  window.digitalData.user.b2bProfile.userID = userId || {};
  window.digitalData.user.b2bProfile.accountID = window.digitalData.user.b2bProfile.accountID || {};
  window.digitalData.user.b2bProfile.accountID = accountId || {};
  window.digitalData.user.b2bProfile.shipToID = window.digitalData.user.b2bProfile.shipToID || {};
  window.digitalData.user.b2bProfile.shipToID = shipToId || {};
  window.digitalData.user.b2bProfile.userTradeType = window.digitalData.user.b2bProfile.userTradeType || {};
  window.digitalData.user.b2bProfile.userTradeType = userTradeType || {};
};

export const setProductInfo = ({ omsId, productName, brand }) => {
  window.digitalData.product = window.digitalData.product || [];
  const productInfo = {
    sku: `${omsId}`,
    productName,
    manufacturer: `${brand}`,
    productType: 'merchandise',
  };

  window.digitalData.product.push(productInfo);
};

export const setUserLocalization = (storeInfo) => {
  if (typeof window !== 'undefined') {
    if (typeof window?.digitalData?.user !== 'undefined') {
      window.digitalData.user.localization = {};
      const zipDetails = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
      const locationInfo = {
        gpsPermission: 'granted',
        inStoreNumber: 'not in store',
        method: 'default',
        storeState: getStateFromZipcode(storeInfo?.storeZip) || '',
        storeZip: storeInfo?.storeZip,
        storeNumber: `${storeInfo?.storeId}`,
        storeName: storeInfo?.storeName,
        userZip: zipDetails?.zipcode || '30339'
      };

      window.digitalData.user.localization = locationInfo;
      tryInitialize();
    }
  }
};

export const setSiteInfo = (siteInfo) => {
  if (!window.digitalData.site) {
    window.digitalData.site = {};
  }
  window.digitalData.site = siteInfo;
};

export const setPageErrorInfo = (errorObject) => {
  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }
  window.digitalData.page.error = window.digitalData.page.error || [];
  window.digitalData.page.error.push(errorObject);
};

export const setProductImpressions = (productImpressions) => {
  if (!window.digitalData.content) {
    window.digitalData.content = {};
    window.digitalData.content.product = [];
  }
  productImpressions.map((productInfo) => window.digitalData.content.product.push(productInfo));
};

export const setProductImpressionsEmpty = () => {
  if (!window.digitalData.content) {
    window.digitalData.content = {};
    window.digitalData.content.product = [];
  }
  window.digitalData.content.product = [];
};